import BracketGameFixtureScoreModel from "./BracketGameFixtureScoreModel";

export default class BracketGameFixturesModel {
  public matchId: string = "";
  public participantOne: string = "";
  public participantTwo: string = "";
  public winner: string | null = "";
  public homeParticipant: string | null = "";
  public startDate: string = "";
  public score: BracketGameFixtureScoreModel =
    new BracketGameFixtureScoreModel();
}
